import type {
  TCacheBustKeys,
  TCacheBustState,
} from '~/interfaces/states/cachebust.state';
import { useStorageService } from '~/composables/services/useStorageService';

export const useCachebust = () => {
  const $storageService = useStorageService();

  const caches = useState<TCacheBustState>(
    'cache-bust',
    () =>
      new Map(
        $storageService.getSessionStorage({
          key: 'cache-bust',
        }),
      ),
  );

  const persistCacheBust = () =>
    $storageService.setSessionStorage({
      key: 'cache-bust',
      data: Array.from(caches.value.entries()),
    });

  const setCacheBust = (key: TCacheBustKeys) => {
    caches.value.set(key, {
      key,
      value: crypto.randomUUID(),
      executed: new Date(),
    });

    persistCacheBust();
  };

  const getCacheBust = (key: TCacheBustKeys) => {
    const cache = caches.value.get(key);
    if (!!cache) {
      caches.value.delete(key);
      persistCacheBust();
      return cache.value;
    }
  };

  return { caches, setCacheBust, getCacheBust };
};
